import { render } from 'preact'
import './styles/index.scss'
import { App } from '@/components/App/App'
import { initAuthState } from '@/state/auth'

initAuthState()

const root = document.getElementById('root')
if (root) {
  render(<App />, root)
}
